import React from "react";
export default function MissingKeyBadge() {
  return null; // stub: replace with your i18n missing-key indicator
}
